<template>
    <span v-for="i in pageSize" :key="i">
        <div class=" dark:bg-gray-800 bg-gray-100 w-full h-50 rounded-lg flex flex-row py-2 gap-x-8 px-5">
            <div class="flex items-center w-6">
                <div s="h-6 w-6 rounded-full transition-colors duration-300 select-none cursor-pointer">
                    <div class="w-5 h-5 rounded-full bg-gray-400"></div>
                </div>
            </div>
            <div class="flex flex-col content-around h-full w-1/2 gap-y-2 animate-pulse">
                <div><div class="w-full h-3 bg-gray-400 rounded-full"></div></div>
                <div><div class="w-4/5 h-3 bg-gray-400 rounded-full"></div></div>
                <div><div class="w-3/5 h-3 bg-gray-400 rounded-full"></div></div>
                <div><div class="w-3/5 h-3 bg-gray-400 rounded-full"></div></div>
                <div class="mt-2">
                    <div class="w-1/2 h-3 bg-gray-400 rounded-full"></div>
                    <div class="mt-2 w-1/2 h-3 bg-gray-400 rounded-full"></div>
                </div>
                <div class="mt-4 flex flex-row items-center text-gray-400">
                    <span class="material-icons md-12">location_on</span>
                    <div class="w-4/5 h-3 bg-gray-400 rounded-full"></div>
                </div>
            </div>
            <div class="w-1/4 justify-center self-center">
                <div class="flex flex-col gap-y-2">
                    <div>
                        <p class="text-center text-sm text-gray-500 uppercase">Regulamentação</p>
                        <div class="w-1/2 m-auto h-3 bg-gray-400 animate-pulse mt-1 rounded-full"></div>
                    </div>
                    <div>
                        <p class="text-center text-sm text-gray-500 uppercase">Região</p>
                        <div class="w-1/2 m-auto h-3 bg-gray-400 animate-pulse mt-1 rounded-full"></div>
                    </div>
                    <div>
                        <p class="text-center text-sm text-gray-500 uppercase">Faturamento</p>
                        <div class="w-1/2 m-auto h-3 bg-gray-400 animate-pulse mt-1 rounded-full"></div>
                    </div>
                </div>
            </div>
            <div class="w-1/5 justify-center self-center flex flex-col gap-y-2 items-center">
                <p class="text-gray-500">PESQUISADOR</p>
                <div class="w-16 h-16 bg-gray-200 rounded-full"></div>
                <div class="w-3/4 h-3 bg-gray-400 animate-pulse rounded-full"></div>
            </div>
        </div>
    </span>
</template>

<script>
export default {
    props: ['pageSize']
}
</script>

<style>

</style>